import {
    onCLS, onFCP, onTTFB, onINP, onLCP
} from 'web-vitals';

import { report } from '../utils/base';

/**
 * @description Send web vitals results to Google Analytics
 */
export function webVitals(): void {
    /**
     * @function
     * @description initialize sending to Google Analytics
     * @param metric object with metric data
     */
    function sendToGoogleAnalytics(metric) {
        report('web-vitals', {
            'event-action': metric.name,
            value: metric.delta,
            'metric-id': metric.id
        });
    }

    onCLS(sendToGoogleAnalytics);
    onLCP(sendToGoogleAnalytics);
    onINP(sendToGoogleAnalytics);
    onFCP(sendToGoogleAnalytics);
    onTTFB(sendToGoogleAnalytics);
}
